import React from "react"
import "./Iconos.css"
import { MdPlaylistAddCheck } from "react-icons/md"

const IconoCalidad = (props) => {
  return (
    <span
      className={
        "icono-mp" +
        (props.background ? " background-calidad" : "") +
        " noprint"
      }
    >
      <MdPlaylistAddCheck />
    </span>
  )
}

export default IconoCalidad